import React from 'react';
import { BRAND, Lnk, usePageMeta } from './shared';

const VALUES = [
  { t: 'Built for belonging', d: 'Membership organizations run on connection. Everything we build starts with helping members feel seen, included, and engaged.' },
  { t: 'Legacy-minded', d: 'These communities span generations. We design for continuity: history, traditions, and trust that carry forward.' },
  { t: 'Yours, end to end', d: 'Every organization deserves a home that looks and feels like its own. Branding, hierarchy, and privacy are first-class, not afterthoughts.' },
  { t: 'Earnest about trust', d: 'We protect member data and identities like they’re our own, with privacy and access controls at the core.' },
];

const About: React.FC = () => {
  usePageMeta('About Us');
  return (
    <>
      <section className="page-head">
        <div className="container">
          <h1>About {BRAND}</h1>
          <p>A konklave is a gathering. We build the place where member-led organizations gather: one app to connect, engage, and empower every member.</p>
        </div>
      </section>

      <section className="page-body">
        <div className="container">
          <div className="prose">
            <h2>Our mission</h2>
            <p>
              Fraternities, sororities, civic organizations, alumni chapters, and councils do
              extraordinary work, often with tools that were never built for them. {BRAND} brings
              every layer of an organization together in one branded, secure app, so leaders can
              spend less time wrangling logistics and more time on their mission.
            </p>
            <p>
              From the individual member to national leadership, {BRAND} brings together the directory,
              events, chat, newsletters, dues, fundraising, and voting in one experience that
              carries each organization’s own name and colors.
            </p>

            <h2>What we believe</h2>
          </div>

          <div className="grid-4" style={{ marginTop: 18 }}>
            {VALUES.map((v) => (
              <div className="card" key={v.t}>
                <h3>{v.t}</h3>
                <p className="muted small">{v.d}</p>
              </div>
            ))}
          </div>

          <div className="prose" style={{ marginTop: 36 }}>
            <h2>Let’s build your home</h2>
            <p>
              Whether you’re a single chapter or a national organization, we’d love to show you what
              {BRAND} can do. <Lnk to="/contact">Request a demo</Lnk> and we’ll
              tailor a walkthrough to your community.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
